<template>
  <el-dialog :title="title" :visible="show" :append-to-body="true" @update:visible="changeShow" width="350px">
    <!-- <slot /> -->
    <div class="change-container">
      <div class="total-div">
        <!-- <i v-if="list.length > surplus" class="el-icon-warning warning"></i>
        <i v-else class="el-icon-circle-check normal"></i>
        <p>已选择未解锁: <span :class="warningClass">{{list.length}}</span> 条</p>
        <p>已解锁: <span class="normal">{{usedTotal}}</span> 条</p>
        <p>总额度: <span class="normal">{{total}}</span> 条</p> -->

        <p class="num">已选择未解锁：<span :class="warningClass" style="color:#ED6826">{{list.length}}</span>条、已解锁：<span class="normal" style="color:#4CBC9A">{{usedTotalDialogP}}</span>条、<br/>总额度：<span class="normal">{{total}}</span>条</p>
        <p class="tip">额度不足时，按勾选顺序依次扣除额度</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <div class="col-0">
        <i class="el-icon-info"></i>
        <span>额度不足时，按勾选顺序依次扣除额度</span>
      </div> -->
      <div class="col-1">
        <el-button w88 @click="changeShow(false)">取 消</el-button>
        <el-button :loading="loading" type="primary" w88 @click="clickConfirm">保存</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'unlockDialog',
  props: {
    title: {
      type: String,
      default: '提示'
    },
    show: {
      type: Boolean,
      default: false
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    confirmPromise: {
      type: Function,
      default: () => new Promise((resolve, reject) => {
        resolve()
      })
    },
    list: {
      type: Array,
      default: () => []
    },
    usedTotalDialogP:{
      type: Number,
      require:true
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: false
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      total: state => state.user.total,
      usedTotal: state => state.user.usedTotal
    }),
    warningClass () {
      return ['normal', 'warning'][+(this.list.length > this.surplus)]
    }
  },
  watch: {
    show: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
      }
    },
  },
  methods: {
    clickConfirm () {
      this.loading = true
      this.confirmPromise().then(() => {
        this.changeShow(false)
      }).catch((err) => { }).finally(() => { this.loading = false })
    },
    handleClose (done) {
      done()
    },
    changeShow (val) {
      this.$emit('update:show', val)
    }
  }

}
</script>

<style lang="scss" scoped>
.change-container {
  // height: 150px;
  // display: flex;
  //   align-items: center;
  // justify-content: center;
}
.dialog-footer {
  // display: flex;
  // text-align: left;
  .col-0 {
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    align-items: center;
    i {
      font-size: 18px;
      color: #409eff;
      margin-right: 8px;
    }
  }
  .col-1 {
    flex-grow: 0;
    flex-shrink: 0;
  }
}
.total-div {
  // margin-top: 30px;
  // border: 1px solid #f0f2f5;
  // height: 60px;
  // padding: 0 24px;
  // display: flex;
  // align-items: center;
  // width: 500px;
  i {
    font-size: 18px;
    margin-right: 8px;
  }
  p + p {
    // margin-left: 24px;
  }
  .normal {
    color: #5088FF;
  }
  .warning {
    color: #e6a23c;
  }
}
::v-deep {
    .el-dialog{
      .el-dialog__body{
        padding: 24px 24px;
        box-sizing: border-box;
      .total-div{
        .num{
          margin-bottom: 8px;
          color: #333333;
          line-height: 20px;
        }
        .tip{
          color: #999999;
          line-height: 17px;
          font-size: 12px;
        }
      }
     }
     .el-dialog__footer{
        padding: 12px 0;
     }
     .el-button.is-w88{
        padding: 0;
        height: 32px;
        line-height: 32px;
     }
  }

}
</style>
